import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

export const Notification = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: center;
  padding: 0.625rem;
  border-radius: 0.3125rem;
  color: ${color.WHITE};
  background: ${({ type }) => {
    switch (type) {
      case 'warn':
        return color.SAFFRON
      case 'refresh':
        return color.SAFFRON
      case 'error':
        return color.WATERMELON
      case 'disclaimer':
        return color.SUNSET
      case 'success':
      default:
        return color.SCOOTER
    }
  }};

  // keep notifications close to each other, but push away other content
  margin-bottom: 0.625rem;

  &:last-child {
    margin-bottom: 1.25rem;
  }

  & p {
    margin-bottom: 0.625rem;
  }

  & p:last-child {
    margin-bottom: 0rem;
  }
`

export const Icon = styled(BaseIcon)`
  margin-right: 0.4375rem;
  fill: ${color.WHITE};
`

export const Text = styled.div`
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: left;

  & h2,
  & h3 {
    color: ${color.WHITE};
    // lines this up with the icon
    margin-top: -0.1875rem;
  }

  & a {
    color: ${color.WHITE};
    text-decoration: underline;
  }

  & p {
    color: ${color.WHITE};
  }

  & ul {
    padding-left: 0.625rem;
    margin-left: 0.3125rem;
  }

  & li {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`
